import Router from './config/Router/Router';
import StoreProvider from './config/StoreProvider/StoreProvider';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { GoogleOAuthProvider } from '@react-oauth/google';

const App = () => {
  return (
    <GoogleOAuthProvider clientId="659347087315-ihniuivp4934btc7emja1seofin93t8q.apps.googleusercontent.com">
      <StoreProvider>
        <Router />
        <ToastContainer />
      </StoreProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
